// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"1f1799ab","239":"ad1a6b26","732":"f42b7713","947":"2ca5f33c","977":"2fbe7cfe"}[chunkId] + ".chunk.js";
};